<template>
  <div>
    <TerrorZoneNavBar @change-language="onLanguageChanged"/>
    <div id="slot-top_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-top_banner" class="desktop-banner hoz-banner"/>
    <Ad placementName="video_slider"/>
    <div class="calculator-content">
      <h1>{{ $t('exp.levelupTimeCostCalculator') }}</h1>
      <p class="my-3">
        {{ $t('exp.description') }}
      </p>
      <div class="my-5 calculator">
        <div class="input-item long-input-item">
          <div>
            <label for="current-level-dropdown">{{ $t('exp.currentLevel') }}</label>
            <b-form-select id="current-level-dropdown" v-model="currentLevel" class="m-3">
              <b-form-select-option
                v-for="level in currentLevelList"
                :key="level"
                :value="level"
              >
                {{ level }}
              </b-form-select-option>
            </b-form-select>
          </div>
          <div>
            <label for="target-level-dropdown">{{ $t('exp.targetLevel') }}</label>
            <b-form-select id="target-level-dropdown" v-model="targetLevel" class="m-3">
              <b-form-select-option
                v-for="level in targetLevelList"
                :key="level"
                :value="level"
              >
                {{ level }}
              </b-form-select-option>
            </b-form-select>
          </div>
        </div>
        <div class="input-item">
          <label for="ppl-dropdown">{{ $t('exp.playerNumber') }}</label>
          <b-form-select id="ppl-dropdown" v-model="playerNum" class="m-3">
            <b-form-select-option value="1">1</b-form-select-option>
            <b-form-select-option value="2">2</b-form-select-option>
            <b-form-select-option value="3">3</b-form-select-option>
            <b-form-select-option value="4">4</b-form-select-option>
            <b-form-select-option value="5">5</b-form-select-option>
            <b-form-select-option value="6">6</b-form-select-option>
            <b-form-select-option value="7">7</b-form-select-option>
            <b-form-select-option value="8">8</b-form-select-option>
          </b-form-select>
        </div>
        <div class="input-item">
          <label for="anni-dropdown">{{ $t('exp.withAnnihilus') }}</label>
          <img width="30" alt="annihilus" src="@/assets/builds/eq-annihilus.png">
          <b-form-select id="anni-dropdown" v-model="anniExp" class="m-3">
            <b-form-select-option value="0">{{ $t('common.none') }}</b-form-select-option>
            <b-form-select-option value="0.05">+ 5% {{ $t('exp.experience') }}</b-form-select-option>
            <b-form-select-option value="0.06">+ 6% {{ $t('exp.experience') }}</b-form-select-option>
            <b-form-select-option value="0.07">+ 7% {{ $t('exp.experience') }}</b-form-select-option>
            <b-form-select-option value="0.08">+ 8% {{ $t('exp.experience') }}</b-form-select-option>
            <b-form-select-option value="0.09">+ 9% {{ $t('exp.experience') }}</b-form-select-option>
            <b-form-select-option value="0.1">+ 10% {{ $t('exp.experience') }}</b-form-select-option>
          </b-form-select>
        </div>
        <div class="input-item">
          <b-form-checkbox
            id="checkbox-ondal-exp"
            v-model="ondalExp"
            name="checkbox-ondal-exp"
            value="0.05"
            unchecked-value="0"
          >
            <span class="mx-2">{{ $t('exp.withOndal') }}</span>
            <img width="15" alt="Ondal's Wisdom" src="@/assets/builds/eq-lazarusspire.png">
            <span class="mx-2">(+ 5% {{ $t('exp.experience') }})</span>
          </b-form-checkbox>
        </div>
        <div v-if="showTzSelection" class="input-item">
          <label for="tz-dropdown">{{ $t('exp.terrorZones') }}</label>
          <b-form-select id="tz-dropdown" v-model="selectTZ" class="m-3">
            <b-form-select-option value="any">{{ $t('exp.anyTZ') }}</b-form-select-option>
            <b-form-select-option value="s-tier">{{ $t('exp.sTierTZ') }}</b-form-select-option>
          </b-form-select>
        </div>
        <div class="input-item">
          <b-button class="my-2" size="lg" variant="light" @click="calculate">{{ $t('exp.calculate') }}</b-button>
        </div>
      </div>
      <div v-if="showResult" class="calculator">
        <h4>{{ $t('exp.timeEstimate') }}:</h4>
        <p>{{ resultText }}</p>
      </div>
    </div>
    <div id="slot-btm_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-btm_banner" class="desktop-banner hoz-banner"/>
    <TerrorZoneFooter class="mt-4"/>
  </div>
</template>

<script>
import Ad from './components/Ad.vue'
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'
import { getLanguage, sum } from '@/utils/common'

export default {
  name: 'ExpCalculator',

  components: {
    Ad,
    TerrorZoneNavBar,
    TerrorZoneFooter,
  },

  data() {
    return {
      currentLevel: '85',
      targetLevel: '99',
      playerNum: '8',
      anniExp: 0,
      ondalExp: 0,
      selectTZ: 'any',
      showResult: false,
      resultText: '',
    }
  },

  computed: {
    currentLevelList () {
      const result = [];
      for (let i = 85; i < 99; i++) {
        result.push(i);
      }
      return result;
    },

    targetLevelList () {
      const result = [];
      for (let i=parseInt(this.currentLevel) + 1; i <= 99; i++) {
        result.push(i);
      }
      return result;
    },
    
    showTzSelection () {
      const level = parseInt(this.targetLevel);
      return level > 95;
    },

    areaAvgHourExp () {
      if (this.selectTZ === 's-tier') {
        return 4620000;
      }
      return 3080000;
    },
  },

  created () {
    const language = getLanguage();
    if (language) {
      localStorage.setItem('language', language);
      this.$i18n.locale = language;
    }
    document.title = "Diablo II Resurrected (D2R) Level Up Time Cost Calculator";
  },

  watch: {
    currentLevel(newLevel) {
      if (parseInt(newLevel) >= parseInt(this.targetLevel)) {
        this.targetLevel = parseInt(newLevel) + 1; 
      }
    }
  },

  methods: {
    onLanguageChanged () {
      if (this.showResult) {
        this.calculate();
      }
    },

    roundHours (hours) {
      return Math.ceil(hours * 10) / 10;
    },

    calculate () {
      const fromLevel = parseInt(this.currentLevel);
      const toLevel = parseInt(this.targetLevel);
      const baalRuns = [];
      const tzRuns = [];
      for (let level = fromLevel + 1; level <= toLevel; level++) {
        if (level < 96){
          const run = this.calculateBaalRun(level);
          run && baalRuns.push(run);
        } else {
          const run = this.calculateTZRun(level);
          run && tzRuns.push(run);
        }
      }
      this.resultText = '';
      const level = toLevel;
      if (baalRuns.length > 0 && tzRuns.length > 0) {
        const baalRunTimes = sum(baalRuns, 'times');
        const baalRunHours = this.roundHours(sum(baalRuns, 'hours'));
        const tzRunHours = this.roundHours(sum(tzRuns, 'hours'));
        const totalHours = baalRunHours + tzRunHours;
        this.resultText = this.$t('exp.timeEstimateBaalTZ', {level, baalRunTimes, baalRunHours, tzRunHours, totalHours});
      }
      else if (baalRuns.length > 0) {
        const times = sum(baalRuns, 'times');
        const hours = this.roundHours(sum(baalRuns, 'hours'));
        this.resultText = this.$t('exp.timeEstimateBaal', {level, times, hours});
      }
      else if (tzRuns.length > 0) {
        const hours = this.roundHours(sum(tzRuns, 'hours'));
        this.resultText = this.$t('exp.timeEstimateTZ', {level, hours});
      }
      this.showResult = this.resultText.length > 0;
    },
    
    calculateBaalRun (level) {
      if (level < 86) {
        return null;
      }
      const eqExpBenifit = 1 + parseFloat(this.anniExp) + parseFloat(this.ondalExp);
      const playerExpBenifit = (parseInt(this.playerNum) + 1) * 0.5;
      const i = level - 86;
      const exp = [
        94937067, 103481403, 112794729, 122946255, 134011418, 
        146072446, 159218965, 173548673, 189168053, 206193177
      ];
      const expPerGame = [
        2421750, // 85 -> 86
        1749951, // 86 -> 87
        1453420, // 87 -> 88
        1066444, // 88 -> 89
        789061, // 89 -> 90
        627376, // 90 -> 91
        478582, // 91 -> 92
        371930, // 92 -> 93
        270633, // 93 -> 94
        175701  // 94 -> 95
      ];
      const times = Math.ceil(exp[i] / (expPerGame[i] * eqExpBenifit * playerExpBenifit));
      const hours = Math.ceil(times * 10 / 27) / 10;
      return {level, times, hours};
    },

    calculateTZRun (level) {
      if (level < 95) {
        return null;
      }
      const eqExpBenifit = 1 + parseFloat(this.anniExp) + parseFloat(this.ondalExp);
      const playerExpBenifit = (parseInt(this.playerNum) + 1) * 0.5;
      const i = level - 95;
      const exp = [206193177, 224750564, 244978115, 267026144, 291058498];
      const expAdjust = [1.5, 1.5, 1.35, 1.2, 1];
      const hours = Math.ceil(exp[i] / expAdjust[i] / (this.areaAvgHourExp * eqExpBenifit * playerExpBenifit));
      return {level, hours};
    },
  }
}
</script>

<style scoped>
.calculator-content {
  color: #fff;
  justify-content: space-around;
  max-width: 800px;
  margin: 40px auto;
  width: 70%;
  min-height: 60vh;
}
.calculator {
  padding: 30px;
  max-width: 500px;
  margin: auto;
  border-radius: 12px;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.inline-block {
  display: inline-block;
}
.input-item {
  margin: 10px 0;
}
.input-item select {
  height: 35px;
  min-width: 60px;
  text-align: center;
}
.long-input-item {
  display: flex;
}
@media (max-width: 600px) {
  .calculator-content {
    width: 90%;
  }
  .long-input-item {
    display: inline-block;
  }
}
</style>
